import { userContext } from '../userManager';

export const apiDocumentDelete = (documentId) =>
  userContext.apiCall({ url: `/documents/${documentId}`, method: 'DELETE', noResBody: true });

export const apiDocumentPatch = (documentId, body) => {
  return userContext.apiCall({ url: `/documents/${documentId}`, method: 'PATCH', body });
};

export const apiDocumentFilePost = (documentId, { file }) =>
  userContext.apiCall({ url: `/documents/${documentId}/files`, method: 'POST', file });

export const apiDocumentFileGet = (documentId, fileId) =>
  userContext.apiCall({ url: `/documents/${documentId}/files/${fileId}`, method: 'GET' });

export const apiDocumentFileDelete = (documentId, fileId) =>
  userContext.apiCall({
    url: `/documents/${documentId}/files/${fileId}`,
    method: 'DELETE',
    noResBody: true,
  });
